// src/components/registration/RegistrationCollege.jsx
import "./style.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signUpUser, addData } from "../../utils/firebase-config";
import { COLLEGE } from "../../utils/constants";

export default function RegistrationCollege(props) {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    college_name: "",
    name: "",
    contact_number_head: "",
    email: "",
  });

  const [password, setPassword] = useState({
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPassword((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password.password.trim() || !password.confirmPassword.trim()) {
      window.alert("Error: Please fill in all the required fields.");
      return;
    }
    if (password.password.trim() !== password.confirmPassword.trim()) {
      window.alert("Password and confirm Password should be same.");
      return;
    }

    if (
      !formData.college_name.trim() ||
      !formData.name.trim() ||
      !formData.contact_number_head.trim()
    ) {
      console.log("Error: Please fill in all the required fields.");
      return;
    }

    const registrationForm = {
      ...formData,
      type: COLLEGE,
      college_unique_code: generateUniqueNumber(),
    };

    try {
      props.loadingStatus?.(true);
      const user = await signUpUser(registrationForm.email, password.password);

      if (user) {
        await addData(registrationForm);
        window.alert(
          `${registrationForm.name}, kindly share your college unique code : ${registrationForm.college_unique_code} with your faculty.`
        );
        navigate("/detail", { state: registrationForm });
      }
    } finally {
      props.loadingStatus?.(false);
    }
  };

  function generateUniqueNumber() {
    const timestamp = Date.now();
    const random = Math.floor(Math.random() * 10000000000);
    return `${timestamp}${random}`.slice(0, 10);
  }

  return (
    <div>
      <div className="detail-description">
        <p>One time college registration required.</p>
        <p>A unique college code will be generated after successful registration.</p>
        <p>All faculty of the college can register using that college code.</p>
      </div>

      <form className="registration-form-div" onSubmit={handleSubmit}>
        <div className="form-login">
          <div className="input-field">
            <label>College Name</label>
            <input
              className="form-input"
              type="text"
              name="college_name"
              value={formData.college_name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-field">
            <label>College Head Name</label>
            <input
              className="form-input"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-field">
            <label>Head Contact Number</label>
            <input
              className="form-input"
              type="tel"
              name="contact_number_head"
              value={formData.contact_number_head}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-field">
            <label>Email</label>
            <input
              className="form-input"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-field">
            <label>Password</label>
            <input
              className="form-input"
              type="password"
              name="password"
              value={password.password}
              onChange={handlePasswordChange}
              required
            />
          </div>

          <div className="input-field">
            <label>Confirm Password</label>
            <input
              className="form-input"
              type="password"
              name="confirmPassword"
              value={password.confirmPassword}
              onChange={handlePasswordChange}
              required
            />
          </div>
        </div>

        <button className="submit-btn" type="submit">
          Register
        </button>

        <div style={{ height: 10 }} />
      </form>
    </div>
  );
}
